const footerLinks = [
  {
    title: '电影分类',
    links: ['动作片在线', '喜剧片免费看', '科幻片高清', '悬疑惊悚', '经典电影全集'],
  },
  {
    title: '热门专题',
    links: ['最新电影大全', '本周热播榜', '新片推荐', '高分神作', '4K超清专区'],
  },
  {
    title: '合作伙伴',
    links: [],
  },
  {
    title: '关于我们',
    links: ['平台介绍', '常见问题', '联系我们', '内容投稿', '商务合作'],
  },
];

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                <a
                  href={
                    section.title === '电影分类'
                      ? '#index'
                      : section.title === '热门专题'
                      ? '#carousel'
                      : section.title === '关于我们'
                      ? '#about'
                      : '#footer'
                  }
                  onClick={(e) => {
                    const href =
                      section.title === '电影分类'
                        ? '#index'
                        : section.title === '热门专题'
                        ? '#carousel'
                        : section.title === '关于我们'
                        ? '#about'
                        : '#footer';
                    if (href !== '#footer') {
                      handleNavClick(e, href);
                    } else {
                      e.preventDefault();
                    }
                  }}
                  className="hover:text-primary-500 transition-colors cursor-pointer"
                >
                  {section.title}
                </a>
              </h4>
              {section.title === '合作伙伴' ? (
                <p className="text-xs text-foreground-400 leading-relaxed">
                  合作伙伴信息即将上线
                </p>
              ) : (
                <ul className="space-y-2.5">
                  {section.links.map((link) => (
                    <li key={link}>
                      <a
                        href={
                          link === '电影分类' || link === '最新电影大全'
                            ? '#index'
                            : link === '本周热播榜'
                            ? '#ranking'
                            : link === '新片推荐'
                            ? '#cards'
                            : link === '平台介绍'
                            ? '#about'
                            : link === '常见问题'
                            ? '#faq'
                            : link === '联系我们'
                            ? '#contact'
                            : '#footer'
                        }
                        onClick={(e) => {
                          const href =
                            link === '电影分类' || link === '最新电影大全'
                              ? '#index'
                              : link === '本周热播榜'
                              ? '#ranking'
                              : link === '新片推荐'
                              ? '#cards'
                              : link === '平台介绍'
                              ? '#about'
                              : link === '常见问题'
                              ? '#faq'
                              : link === '联系我们'
                              ? '#contact'
                              : '#footer';
                          if (href !== '#footer') {
                            handleNavClick(e, href);
                          } else {
                            e.preventDefault();
                          }
                        }}
                        className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/40">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <span className="w-6 h-6 flex items-center justify-center">
                <i className="ri-movie-2-line text-primary-500"></i>
              </span>
              <span className="font-heading text-base font-bold text-foreground-900">天天影院</span>
            </div>

            <p className="text-xs text-foreground-400 text-center">
              天天影院拥有最新电影大全、动作片在线、喜剧片免费看、科幻片高清播放及经典电影全集，
              极速播放不卡顿，海量片库免费高清在线看。
            </p>

            <p className="text-xs text-foreground-400 whitespace-nowrap">
              &copy; 2026 天天影院 版权所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}